<template>
  <div class="category-container">
    <div v-if="title" class="category-title">
      {{ title }}
    </div>
    <div id="channel-tab-filter" class="filter-wrapper font-medium">
      <div v-show="boardShow" class="board-wrap">
        <div class="category-list">
          <div v-for="(item, index) in category" :key="index"
               v-sa-track="[{type: 'click', event: 'component_button_click', data: getCategoryClickTrackData(item.name)}]"
               class="category-item text-overflow-ellipsis"
               :class="{'actived': selectedIndex == index}"
               @click="handleClick(index)"
          >
            {{ item.name }}
          </div>
          <div class="retract-btn">
            <i class="iconfont icon-arrow-top2" @click="boardShow = !boardShow" />
          </div>
        </div>
      </div>
      <div v-show="!boardShow" class="tab-wrap">
        <div class="tabs-container">
          <van-tabs
            v-show="!boardShow"
            v-model="selectedIndex"
            class="column-filter-container"
            type="card"
            color="#ff9f0a"
            :ellipsis="false"
            @click="handleClick"
          >
            <van-tab
              v-for="(item, index) in category"
              :key="index"
              :name="index"
              title-class="filter-tab"
            >
              <template #title>
                <div v-sa-track="[{type: 'click', event: 'component_button_click', data: getCategoryClickTrackData(item.name)}]">
                  {{ item.name }}
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
        <div class="open-btn">
          <i class="iconfont icon-arrow-bottom2" @click="boardShow = !boardShow" />
        </div>
      </div>
    </div>
    <!-- 预留加载占位高度以降低 CLS -->
    <div class="result-wrapper" :style="loadingModules ? { minHeight: '1200px' } : null">
      <template v-if="loadingModules">
        <Loading :show="true" />
      </template>
      <template v-else>
        <template v-if="moduleList.length">
          <DynamicComponent v-if="!!moduleList.length" :style="handleStyles(moduleList)" :locale="locale" :component-list="moduleList" @components-loaded="$emit('components-loaded')" />
        </template>
        <template v-else>
          <div class="exception-wrapper">
            <Exception :tip-text="langContext.emptyNotice" placeholder-class-name="no-avalible-data-img" />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
import Loading from 'components/common/Loading'
import Exception from 'components/common/Exception'

export default {
  name: 'Category',
  components: {
    Loading,
    Exception,
    DynamicComponent: () => import('../touch'),
  },
  mixins: [mixin],
  data() {
    return {
      boardShow: false,
      selectedIndexCache: 0,
    }
  },
  watch: {
    '$route.query': function (newQuery, oldQuery) {
      // 监听URL变化，同步更新组件状态
      if (newQuery.moduleId !== oldQuery.moduleId
          || newQuery.current !== oldQuery.current
          || newQuery.categoryName !== oldQuery.categoryName) {
        this.initFromUrlParams()
      }
    },
  },
  mounted() {
    if (this.targetType === 'module') {
      this.initQueryModule()
    }
  },
  methods: {
    handleStyles(list = []) {
      const componentList = list.filter((item) => item.type !== 49)
      const styles = {
        paddingBottom: '5.33333vw',
        background: '#fff',
      }
      if (!componentList.length) {
        return {
          ...styles,
        }
      }
      const firstComponent = componentList[0]
      if (!firstComponent.content) {
        return {
          ...styles,
        }
      }
      const contentData = JSON.parse(firstComponent.content)
      const styleAttr = {}
      if (!contentData.componentName.includes('Banner')) {
        styleAttr.paddingTop = '4.26667vw'
      }
      return {
        ...styleAttr,
        ...styles,
      }
    },
    /**
     * 初始查询模块列表数据
     */
    async initQueryModule() {
      let moduleList = []
      const {
        current, moduleId, group = 0, anchorId,
      } = this.$route.query
      console.log('initQueryModule', this.anchor, this.category, { current, moduleId, anchorId })
      try {
        if (this.enableGroup) {
          const groupIndex = group !== undefined ? parseInt(group, 10) : 0
          const validGroupIndex = (groupIndex >= 0 && groupIndex < this.categoryGroup.length) ? groupIndex : 0
          const groupChildren = this.categoryGroup[validGroupIndex].children

          if (this.anchor && anchorId) {
            // 分组+锚点模式：在平铺的 category 里搜索 anchorId，不受 group 参数限制
            const curId = +String(anchorId).split('-').pop()
            const findIndex = this.category.findIndex((cat) => cat.moduleList.some((m) => m.id === curId))
            if (findIndex >= 0) {
              this.selectedIndex = findIndex
              this.selectedIndexCache = findIndex
              moduleList = this.category[findIndex].moduleList
            } else {
              moduleList = this.category[0].moduleList
            }
          } else {
            // 普通分组模式：按 current 索引加载
            const categoryIndex = current !== undefined ? parseInt(current, 10) : 0
            const validCategoryIndex = (categoryIndex >= 0 && categoryIndex < groupChildren.length) ? categoryIndex : 0
            this.selectedIndex = validCategoryIndex
            this.selectedIndexCache = validCategoryIndex
            moduleList = groupChildren[validCategoryIndex]?.moduleList || []
          }
        } else if (this.anchor) {
          // 锚点模式：通过 anchorId 定位对应 tab，只加载该 tab 数据
          if (anchorId) {
            const curId = +String(anchorId).split('-').pop()
            const findIndex = this.category.findIndex((item) => item.moduleList.some((m) => m.id === curId))
            if (findIndex >= 0) {
              this.selectedIndex = findIndex
              this.selectedIndexCache = findIndex
              moduleList = this.category[findIndex].moduleList
            } else {
              moduleList = this.category[0].moduleList
            }
          } else {
            moduleList = this.category[0].moduleList
          }
        } else if (moduleId && parseInt(moduleId, 10) === this.moduleId && current !== undefined) {
          // validate current is valid index
          const currentIndex = parseInt(current, 10)
          if (currentIndex >= 0 && currentIndex < this.category.length) {
            moduleList = this.category[currentIndex].moduleList
            this.selectedIndex = currentIndex
          } else {
            moduleList = this.category[0].moduleList
          }
        } else {
          moduleList = this.category[0].moduleList
        }
      } catch (error) {
        console.log(error)
      }

      await this.queryModuleList(moduleList, this.moduleId)

      // 兜底：当分类下没有可渲染模块（如配置的模块后端未返回 content）时，
      // 模板会走 Exception 分支而不会 emit components-loaded，导致父级渲染门锁死，
      // Category 之后的所有组件与页面 footer 永久无法渲染。此处主动放行。
      if (!this.moduleList.length) {
        this.$emit('components-loaded')
      }

      this.$nextTick(() => {
        this.initFromUrlParams()
      })
    },

    /**
     * 点击分类
     * @param {Number} index 索引
     */
    handleClick(index) {
      const item = this.category[index]
      if (this.targetType === 'page') {
        window.open(item.pageUrl, '_blank')
        return
      }
      if (index === this.selectedIndexCache) return

      this.selectedIndex = index
      this.selectedIndexCache = index

      // 更新URL参数 - 记录当前组件的moduleId和current index
      this.updateUrlWithCurrentState(index, item)

      this.queryModuleList(item.moduleList)
      this.boardShow = false
    },
    scrollToAnchorId(anchorId) {
      this.updateQueryWithoutNavigation({ anchorId })
      this.waitForElementById(anchorId)
        .then((el) => {
          const topHeader = document.getElementById('topHeader');
          const offset = topHeader ? topHeader.offsetHeight : 70;
          const top = el.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        })
        .catch((err) => {
          console.warn(`滚动err ykk: ${err.message}`);
        });
    },
    waitForElementById(id, timeout = 10000, interval = 300) {
      return new Promise((resolve, reject) => {
        const start = Date.now();

        const timer = setInterval(() => {
          const el = document.getElementById(id);
          if (el) {
            clearInterval(timer);
            resolve(el);
          } else if (Date.now() - start > timeout) {
            clearInterval(timer);
            reject(new Error(`元素 #${id} 在 ${timeout}ms 内未加载完成`));
          }
        }, interval);
      });
    },

    /**
     * 替换地址栏但不触发跳转 不触发路由中间件
     * @param params
     */
    updateQueryWithoutNavigation(params = {}) {
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) {
          searchParams.delete(key);
        } else {
          searchParams.set(key, value);
        }
      });
      const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
      window.history.replaceState(null, '', newUrl);
    },
  },
}
</script>

<style lang="scss" scoped>
.category-title {
  font-size: 24px;
  font-family: Roboto-Flex, sans-serif;
  color: var(--txt-color-lv4);
  font-weight: bold;
  padding: 14px 16px 12px 16px;
}

.filter-wrapper {
  // margin-bottom: 35px;

  .tab-wrap {
    display: flex;
    justify-content: center;
    position: relative;
    padding-right: 16px;

    .tabs-container {
      flex: 1;
      width: 313px;
      height: 38px;
      padding: 4px 0;
      border-right: 1px solid #ebebeb;

      /deep/.van-tabs__nav {
        background: none;
      }

      /deep/.van-tabs__nav--card {
        border: none;
        margin: 0;

        .filter-tab {
          height: 30px;
          padding: 0 10px;
          border-color: #ebebeb !important;
          border-style: solid;
          border-width: 1px;
          border-radius: 15px;
          margin-right: 8px;
          background-color: #fff;

          .van-tab__text > div {
            max-width: 128px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &:first-child {
            margin-left: 16px;
          }
        }

        .van-tab__text {
          color: #262626;
          font-size: 18px;
        }

        .van-tab--active {
          border-color: var(--txt-color-link) !important;

          .van-tab__text {
            color: #fff;
          }
        }
      }
    }
  }

  .board-wrap {
    padding: 14px 16px 6px 16px;

    .category-list {
      display: flex;
      flex-wrap: wrap;
    }

    .category-item {
      max-width: 148px;
      height: 30px;
      line-height: 28px;
      padding: 0 10px;
      margin: 0 12px 10px 0;
      background: #fff;
      border-radius: 16px;
      font-size: 18px;
      color: #262626;
      border: 1px solid #ebebeb;

      &.actived {
        background: var(--txt-color-link);
        color: #fff;
        border-color: var(--txt-color-link);
        font-weight: 500;
      }
    }
  }

  .retract-btn,
  .open-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background: #fff;
    border: 1px solid #ebebeb;
    border-radius: 15px;

    i {
      font-size: 18px;
      transform: scale(0.8);
      color: #262626;
    }
  }

  .open-btn {
    margin: 4px 0 0 15px;
  }
}

.exception-wrapper {
  padding: 15vh 0 0;
}
</style>
